import { Link } from "react-router-dom";

const TextBlock = ({ block }) => {
  const switchTextBlocks = (block) => {
    switch (block.type) {
      case "regular":
        return (
          <span key={block.type + "-" + Math.random()}>
            {block.value}
          </span>
        );
      case "text-link":
        return (
          <Link
            key={block.type + "-" + Math.random()}
            to={block.link}
            target={block.newTab ? "_blank" : "_self"}
            className="text-link"
          >
            {block.value}
          </Link>
        );
      case "highlight":
        return (
          <span
            key={block.type + "-" + Math.random()}
            className="text-highlight"
          >
            {block.value}
          </span>
        );
      case "new-line":
        return <br key={block.type + "-" + Math.random()} />;
      default:
        return null;
    }
  };

  return (
    <p className="text-block">
      {block.content.map((textSubBlock) => switchTextBlocks(textSubBlock))}
    </p>
  );
};

export default TextBlock;